import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query';

import {
  RQ_DASHBOARD_ATTENDANCE_API,
  RQ_DASHBOARD_BILLS_API,
  RQ_DASHBOARD_SALARY_API,
  RQ_MONTHLY_SALES,
} from './constants';
import {rqCreateRequest} from './rqHttpUtils';

export const RQGetDashboardSalary = (filterData, token, options = {}) => {
  return useQuery({
    queryKey: ['rq_dashboard_salary', filterData],
    queryFn: async () => {
      return (
        (await rqCreateRequest(
          RQ_DASHBOARD_SALARY_API,
          filterData,
          token,
          null,
        )) || {}
      );
    },
    enabled: !!token && !!filterData,
    ...options,
  });
};

export const RQGetDashboardBills = (filterData, token, options = {}) => {
  return useQuery({
    queryKey: ['rq_dashboard_bills', filterData],
    queryFn: async () => {
      return (
        (await rqCreateRequest(
          RQ_DASHBOARD_BILLS_API,
          filterData,
          token,
          null,
        )) || {}
      );
    },
    enabled: !!token && !!filterData,
    ...options,
  });
};

export const RQGetDashboardAttendance = (filterData, token, options = {}) => {
  return useQuery({
    queryKey: ['rq_dashboard_attendance', filterData],
    queryFn: async () => {
      return (
        (await rqCreateRequest(
          RQ_DASHBOARD_ATTENDANCE_API,
          filterData,
          token,
          null,
        )) || {}
      );
    },
    enabled: !!token && !!filterData,
    ...options,
  });
};
export const RQGetMonthlySales = (token, options = {}) => { 
  return useMutation({
    mutationKey: ['rq_get_monthly_sales'],
    mutationFn: async ({year, month}) => { 
      return rqCreateRequest(
        RQ_MONTHLY_SALES,
        {year, month},
        token, 
        null,
      );
    },
    onSuccess: () => {
      options?.onSuccess?.();
    },
    onError: () => {
      options?.onError?.();
    },
  });
};
